import { PaymentMethod } from '../../../../../../../../../../../services/exports/Constants';

export default {
  title: 'Metody płatności',
  payment_options: {
    [PaymentMethod.Card]: 'Karta kredytowa',
  },
};
